// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.9/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.9/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".root-search[data-v-d7857cda]{clear:left;margin:10px;position:relative}.zoom[data-v-d7857cda],.close[data-v-d7857cda]{position:absolute;top:12px;right:10px;z-index:10}.close[data-v-d7857cda]{right:13px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
